module.exports = "<span class=\"d-inline-block\">\n  {{name|e}}\n  {% for spec in specifications %}\n    <small>\n        <span class=\"d-block\">{{spec|e}}</span>\n    </small>\n  {% endfor %}\n</span>\n";
